/**
 * Custom polyfill for Object.fromEntries
 * for MS Edge/IE11 supportt
 * @param {Array<[key, value]>} entriesArr
 * @return {Object} - Object based on entries argument 
 */
const objectFromEntries = (entriesArr) => {
    return entriesArr.reduce(
        (accObj, [ key, value ]) => (
            {
                ...accObj,
                [key]: value
            }
        )
    , {})
}

export {
    objectFromEntries
}